import { CurrencyPipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Color, ScaleType } from '@swimlane/ngx-charts';

@Component({
  selector: 'compras-graphs',
  templateUrl: './compras-graph.component.html',
  styleUrls: ['./compras-graph.component.scss']
})

export class ComprasGraphComponent implements OnInit {

  @Input() viewGraph: [number, number] = [0, 0];
  @Input() semanaMesSeleccionado: IValueGraph[] = []
  @Input() cargandoGraph = false
  @Input() sinInformacion = 'Aún no hay información para mostrar'

  // Configuraciones de la grafica
  colorScheme: Color = {
    name: 'azulPersonalizado',
    selectable: true,
    group: ScaleType.Ordinal,
    domain: ['#009bdd']
  };
  
  public showXAxis = true
  public showYAxis = false
  public showDataLabel = true
  public gradient = false
  public showLegend = false
  public showXAxisLabel = false
  public showYAxisLabel = false
  public tooltipDisabled = false
  public roundEdges = false
  public trimXAxisTicks = true
  public yAxis = false

  constructor(private currency: CurrencyPipe) { }

  ngOnInit() { }

  public formatDataLabel = (value: any) => this.currency.transform(value)

}

interface IValueGraph {
  value?: number | string
  name?: string
}
